<div class="layout-container">
	<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
	<div class="spinner" *ngIf="loading">
		<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
	</div>

	<div class="mdc-layout-grid__inner" [ngClass]="{ 'margin-bottom-5em': embedded }">
		<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
			<div class="row mx-0 justify-content-between">
				<div class="col-auto px-0">
					<span class="fs-20px fw-500 d-block mb-2">{{ locale.translations['payment']['n597'] }}</span>
				</div>
				<div
					class="col-auto cursor-pointer d-flex align-items-center"
					[ngClass]="{ 'text-start': locale.lang !== 'en', 'text-end': locale.lang === 'en' }"
					(click)="onOpenWhatsapp()"
				>
					<img [src]="'/assets/images/payment/whatsapp.svg' | s3Image" [ngClass]="{ 'me-2': locale.lang === 'en', 'ms-2': locale.lang !== 'en' }" />
					<span class="help">{{ locale.translations['whats-new']['new-auth']['n572'] }}</span>
				</div>
			</div>
			<span class="fg-light-grey d-block">
				{{ this.paymentMode === 'voucherCode' ? locale.translations['payment']['n598'] : locale.translations['payment']['n632'] }}
			</span>

			<!-- Voucher Code -->
			<mat-radio-group [(ngModel)]="voucherType" name="voucherType" class="custom-radio-group my-3">
				<mat-radio-button value="asiacell" class="custom-expansion-panel px-3">
					<div class="custom-panel-title" [ngClass]="{ 'other-expansion': locale.lang !== 'en' }">
						<img [src]="'/assets/images/payment/asiacell-logo.svg' | s3Image" class="voucher-img" />
					</div>
				</mat-radio-button>

				<!-- Transfer Mobile Balance -->
				<mat-radio-button value="korek" class="custom-expansion-panel px-3">
					<div class="custom-expansion-panel-header" [ngClass]="{ 'other-expansion': locale.lang !== 'en' }">
						<div class="custom-panel-title">
							<img [src]="'/assets/images/payment/korek-logo.svg' | s3Image" class="voucher-img" />
						</div>
					</div>
				</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>

	<div class="button-container d-flex justify-content-between">
		<button mat-stroked-button type="button" class="checkout-btn w-100 fw-400" color="primary" (click)="onBack()">
			<mat-icon class="mat-icon-rtl-mirror arrow-btn mx-2">arrow_back</mat-icon>
			{{ locale.translations['payment']['n622'] }}
		</button>

		<button
			mat-flat-button
			type="submit"
			[disabled]="!voucherType || loading"
			class="checkout-btn w-100 ms-16px fw-400"
			color="primary"
			(click)="onSubmit()"
		>
			{{ locale.translations['whats-new']['default']['n436'] }}
			<mat-icon class="mat-icon-rtl-mirror arrow-btn mx-2 fg-light-grey">arrow_forward</mat-icon>
		</button>
	</div>
</div>
